export enum DynamicCardTheme {
  PRIMARY_A = 'Primary A',
  PRIMARY_B = 'Primary B',
  GREY_A = 'Grey A',
  GREY_B = 'Grey B',
  WHITE = 'white',
  DARK = 'dark',
  GRADIENT_LEFT = 'Gradient Left',
  GRADIENT_RIGHT = 'Gradient Right',
}

export type EdsDynamicCardType =
  | 'primary'
  | 'secondary-a'
  | 'secondary-b'
  | 'secondary-c'
  | 'white'
  | 'dark'
  | 'gradient-left'
  | 'gradient-right';

export const DynamicCardThemeMap: Map<
  DynamicCardTheme,
  EdsDynamicCardType
> = new Map([
  [DynamicCardTheme.PRIMARY_A, 'primary'],
  [DynamicCardTheme.PRIMARY_B, 'secondary-a'],
  [DynamicCardTheme.GREY_A, 'secondary-b'],
  [DynamicCardTheme.GREY_B, 'secondary-c'],
  [DynamicCardTheme.WHITE, 'white'],
  [DynamicCardTheme.DARK, 'dark'],
  [DynamicCardTheme.GRADIENT_LEFT, 'gradient-left'],
  [DynamicCardTheme.GRADIENT_RIGHT, 'gradient-right'],
]);

export interface DynamicBlockCTAButton {
  displayText?: string;
  href?: string;
  target?: boolean;
  isExternalLink?: boolean;
}
